import { combineReducers } from 'redux';

import { reducer as supplier } from './State/supplier';
import { reducer as showSupplierModal } from './State/showSupplierModal';
import { reducer as showSupplierItemModal } from './State/showSupplierItemModal';
import { reducer as supplierItemForEdit } from './State/supplierItemForEdit';

export default combineReducers({
  supplier,
  showSupplierModal,
  showSupplierItemModal,
  supplierItemForEdit,
});
